import React, { useContext } from 'react'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import Grid from '@mui/material/Grid';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import { TextField } from '@mui/material';
import axios from "axios"
import { Box } from '@mui/system';
import { AuthContext } from '../authContext/AuthContext';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const UpdateUserPassword = ({updateDialog, handleClose, updateUserId}) => {
    const [username,setUsername] = React.useState("");
    const [password,setPassword] = React.useState("");
    const [disabled, setDisabled] = React.useState(false);
    const {user} = useContext(AuthContext)
    const resetField = async() => {
      setPassword("")
    }
    const handleCloseDialog = async() => {
      handleClose();
      resetField();
    };
    React.useEffect(() => {
      const getItem = async() => {
        if(updateUserId) {
          try {
            const res = await axios.get("/users/" + updateUserId, {headers: {token:"Bearer " + user.token}})
            setUsername(res.data.username)
          } catch (err) {
            console.log(err)
          }
        }
      };
      getItem();
    },[updateUserId, user]);

    React.useEffect(() => {
      const validate = async() => {
        setDisabled(username.trim().length === 0
        || password.trim().length === 0)
      };
      validate();
    },[username, password]);

    const updateUserPassword = async() => {
      try {
        const updateUser = {password}
        await axios.put("/users/changePassword/" + updateUserId, updateUser, {headers: {token:"Bearer " + user.token}})
        handleClose();
        resetField();
      } catch (err) {
        console.log(err)
      }
    };
  return (
    <div>
      <Dialog
        open={updateDialog}
        onClose={handleCloseDialog}
        TransitionComponent={Transition}
        sx={{width: "100vw"}}
      >
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleCloseDialog}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Change Password
            </Typography>
          </Toolbar>
        </AppBar>
        <Box sx={{margin: "2vh"}}>
          <Grid container spacing={2}>
            <Grid item xs={12}><TextField label="User Name" variant="standard" fullWidth disabled value={username}/></Grid>
            <Grid item xs={12}><TextField label="Password" type="password" variant="standard" fullWidth value={password} onChange={(event)=> setPassword(event.target.value)}/></Grid>
            <Grid item xs={12}>
              <Button autoFocus variant="contained" onClick={updateUserPassword} disabled={disabled} fullWidth>
              Change Password
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Dialog>
    </div>
  )
}

export default UpdateUserPassword
